import React, {useEffect, useState, useCallback, useMemo} from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import lodash from 'lodash';

import styles from './modal.module.css';

import {getGames} from '../../../../actions/my-topic';
import {getTextScore} from '../../../../actions/dashboard';
import Loading from '../../../../components/loading';
import useDisableScrollDocument from '../../../../useHook/useDisableScrollDocument';

function getTableDate(currentDate) {
    return [
        moment(currentDate, 'YYYY/MM/DD').subtract(3, 'd').format('M/D'),
        moment(currentDate, 'YYYY/MM/DD').subtract(2, 'd').format('M/D'),
        moment(currentDate, 'YYYY/MM/DD').subtract(1, 'd').format('M/D'),
        moment(currentDate, 'YYYY/MM/DD').format('M/D'),
        moment(currentDate, 'YYYY/MM/DD').add(1, 'd').format('M/D'),
        moment(currentDate, 'YYYY/MM/DD').add(2, 'd').format('M/D'),
        moment(currentDate, 'YYYY/MM/DD').add(3, 'd').format('M/D'),
    ];
}

function TopicChooseUser(props) {
    useDisableScrollDocument();

    const [leagues, setLeagues] = useState([]);
    const [league, setLeague] = useState(1);
    const [currentDate, setCurrentDate] = useState(moment().format('YYYY/MM/DD'));
    const [loading, setLoading] = useState(false);
    const [chooseDate, setChooseDate] = useState(new Date());

    const [listDate] = useState([
        { name: '前の週', value: moment().subtract(7, 'd').format('YYYY/MM/DD') },
        { name: '前日', value: moment().subtract(1, 'd').format('YYYY/MM/DD') },
        { name: '今日', value: moment().format('YYYY/MM/DD') },
        { name: '翌日', value: moment().add(1, 'd').format('YYYY/MM/DD') },
        { name: '次の週', value: moment().add(7, 'd').format('YYYY/MM/DD') }
    ]);

    const [dateTable, setDateTable] = useState(getTableDate(currentDate));

    const dispatch = useDispatch();

    useEffect(() => {
        if(!currentDate) return;
        fetchGames();
    }, [currentDate]);

    const fetchGames = useCallback(async () => {
        setLoading(true);
        const response = await dispatch(getGames({current_date: currentDate}));
        setDateTable(getTableDate(currentDate));
        setLeagues(response);
        setLoading(false);
    }, [currentDate]);

    const onItemSelect = useCallback((item) => {
        props.onChange(item);
    }, []);

    const teamsLeague = useMemo(() => {
        if(leagues.length === 0) return [];
        const findData = leagues.find(item => item.id === league) || {teams: []};
        return findData.teams;
    }, [leagues, league]);

    const renderCol = useCallback((date, team, idx) => {
        const findData = team.schedule.find(game => moment(game.game_date, 'YYYY-MM-DD').format('M/D') === date);
        if(!findData) return <td key={idx} className={styles.tableBodyTr} />;

        const isSameTeam = findData.home_team.id === team.team.id || findData.away_team.id === team.team.id;
        if(!isSameTeam) return <td key={idx} className={styles.tableBodyTr} />;

        const resultScore = getTextScore(findData.result);
        const teamName = findData.home_team.id === team.team.id ? findData.away_team.team_name_s : findData.home_team.team_name_s;
        let pitcherName = '';

        if(findData.pitchers && findData.home_team.id === team.team.id) {
            pitcherName = lodash.get(findData.pitchers.away, 'player_name', '');
        }

        if(findData.pitchers && findData.away_team.id === team.team.id) {
            pitcherName = lodash.get(findData.pitchers.home, 'player_name', '');
        }

        return <td key={idx} className={classNames(styles.tableBodyTr, styles.cursorPointer)} onClick={() => onItemSelect(findData)}>
            <span style={{lineHeight: '20px', fontSize: 13, textAlign: 'center'}}>
                <a className={styles.link}>
                    {`${resultScore} ${teamName}`}
                    <span style={{display: 'block'}}>{pitcherName ? '先発:' + pitcherName: ''}</span>
                </a>
            </span>
        </td>;
    }, []);

    const renderTeam = useCallback((item, index) => {
        return <tr key={index}>
            <td className={styles.tableBodyTr} >
                {item.team.team_name_s}
            </td>
            {dateTable.map((date, idx) => renderCol(date, item, idx))}
        </tr>
    }, [dateTable]);

    return <div className={styles.modalWrapper}>
        <div style={{position: 'absolute', height: '100%', width: '100%'}} onClick={props.onClose}/>
        <div className={styles.modalContentGame}>
            <h4 className={styles.modalTitle}>
                ゲームを選択
            </h4>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    {leagues.map((item, index) => {
                        return <div key={index} className={classNames(styles.tab, league === item.id && styles.tabActive)} onClick={() => setLeague(item.id)}>
                        {item.league_name}
                    </div>
                    })}
                </div>
                <div className={styles.topicGameDateWrapper}>
                    <div className={styles.dateWrapper}>
                        {listDate.map((item, idx) => {
                            return <button onClick={() => setCurrentDate(item.value)} className={classNames(styles.dateButton, currentDate === item.value && styles.active)} key={idx}>{item.name}</button>
                        })}
                    </div>
                </div>
                <div style={{position: 'relative'}}>
                    <DatePicker
                        className={'dsa-datepicker'}
                        dateFormat="yyyy/MM/dd"
                        selected={chooseDate}
                        onChange={date => {
                            setChooseDate(date);
                            setCurrentDate(moment(date).format('YYYY/MM/DD'));
                        }} />
                </div>
            </div>

            <div className={styles.topicChooseGameTable}>
                <table>
                    <thead>
                        <tr>
                            <th style={{width: '20%'}} className={styles.tableHeader}>
                                <span>チーム</span>
                            </th>
                            {dateTable.map((date, idx) => {
                                return <th key={idx} style={{width: 'calc(80%/7)'}} className={styles.tableHeader}>
                                    <span>{date}</span>
                                </th>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {teamsLeague.map((item, index) => {
                            return renderTeam(item, index);
                        })}
                    </tbody>
                </table>
            </div>
        </div>
        <Loading show={loading}/>
    </div>
}

export default TopicChooseUser;
